import { INewbuildingBroker } from '../../../types/newbuildingBroker';

export const getPartnerRewardsLanding = (newbuildingBroker: INewbuildingBroker | null | undefined): string | null => {
  if (!newbuildingBroker) {
    return null;
  }

  const { availableBrokerFlow, isPartnerRewardsRegistered, partnerRewardsFlowUrl } = newbuildingBroker;

  if (availableBrokerFlow === 'withPartnerRewards' && !isPartnerRewardsRegistered) {
    return partnerRewardsFlowUrl;
  }

  return null;
};
